<template>
  <boxwrap class="ip--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0"
          @click="deleteData()"
        >
          <i class="ico--delete"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading }">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input type="checkbox" @change="checkAll(ips)">
                </checkbox>
              </tbl-td>
              <tbl-td
                name="id"
                :sort="true"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                no
              </tbl-td>
              <tbl-td
                name="created-at"
                :sort="true"
                v-if="checkCol('created_at', tblSetting)"
                @click.native="sort('created_at')"
              >
                created at
              </tbl-td>
              <tbl-td
                name="login id"
                :sort="true"
                v-if="checkCol('login_id', tblSetting)"
                @click.native="sort('login_id')"
              >
                login id
              </tbl-td>
              <tbl-td
                name="login name"
                :sort="true"
                v-if="checkCol('login_name', tblSetting)"
                @click.native="sort('login_name')"
              >
                login name
              </tbl-td>
              <tbl-td
                name="level"
                :sort="true"
                v-if="checkCol('level', tblSetting)"
                @click.native="sort('level')"
              >
                level
              </tbl-td>
              <tbl-td
                name="agent"
                :sort="true"
                v-if="checkCol('agent', tblSetting)"
                @click.native="sort('agent')"
              >
                agent
              </tbl-td>
              <tbl-td
                name="ip-address"
                :sort="true"
                v-if="checkCol('ip_address', tblSetting)"
                @click.native="sort('ip_address')"
              >
                ip address
              </tbl-td>
              <tbl-td
                name="memo"
                :sort="true"
                v-if="checkCol('memo', tblSetting)"
                @click.native="sort('memo')"
              >
                memo
              </tbl-td>
              <tbl-td
                name="updated-at"
                :sort="true"
                v-if="checkCol('updated_at', tblSetting)"
                @click.native="sort('updated_at')"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted-at"
                :sort="true"
                v-if="checkCol('deleted_at', tblSetting)"
                @click.native="sort('deleted_at')"
              >
                deleted at
              </tbl-td>
              <tbl-td></tbl-td>
            </tbl-row>
          </tbl-head>
          <tbl-body>
            <tbl-row
              v-for="(item, index) in ips"
              :key="index"
              @click.native="showUpdateForm(index)"
              :class="{'is-deleted': item.deleted_at}"
            >
              <tbl-td name="checkbox">
                <checkbox
                  @click.native.stop
                >
                  <input
                    type="checkbox"
                    :value="item.id"
                    v-model="selected"
                  >
                </checkbox>
              </tbl-td>
              <tbl-td
                name="id"
                v-if="checkCol('id', tblSetting)"
              >
                {{ item.id }}
              </tbl-td>
              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ item.created_at | date }}
              </tbl-td>
              <tbl-td
                name="login id"
                v-if="checkCol('login_id', tblSetting)"
              >
                {{ item.user.login_id }}
              </tbl-td>
              <tbl-td
                name="login name"
                v-if="checkCol('login_name', tblSetting)"
              >
                {{ item.user.login_name }}
              </tbl-td>
              <tbl-td
                name="level"
                v-if="checkCol('level', tblSetting)"
              >
                --need data--
              </tbl-td>
              <tbl-td
                name="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                --need data--
              </tbl-td>
              <tbl-td
                name="ip-address"
                v-if="checkCol('ip_address', tblSetting)"
              >
                {{ item.ip_address }}
              </tbl-td>
              <tbl-td
                name="memo"
                v-if="checkCol('memo', tblSetting)"
              >
                {{ item.memo }}
              </tbl-td>
              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ item.updated_at | date }}
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ item.deleted_at | date }}
              </tbl-td>

              <tbl-td name="delete-restore">
                <button
                  class="btn--restore"
                  v-if="item.deleted_at"
                  @click.exact="restore(item.id)"
                  @click.stop=""
                >
                  <i class="ico--restore"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="query.page"
            :rows="query.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-ip"
      title="create ip"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>ip address</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  data-vv-scope="form-entry"
                  v-validate="'required'"
                  v-model="ipModel.ip_address"
                >
                <span v-if="errors.has('form-entry.ip_address')">
                  {{ errors.first('form-entry.ip_address') }}
                </span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>user id</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  data-vv-scope="form-entry"
                  v-validate="'required'"
                  v-model="ipModel.user_id"
                >
                <span v-if="errors.has('form-entry.user_id')">
                  {{ errors.first('form-entry.user_id') }}
                </span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Memo</span></div>
            <div class="form-data">

              <div class="textarea-wrap">
                <text-area
                  name="memo"
                  data-vv-scope="form-entry"
                  v-validate="'required'"
                  v-model="ipModel.memo"
                ></text-area>
              </div>
              <span v-if="errors.has('form-entry.memo')">
                {{ errors.first('form-entry.memo') }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-ip"
      title="modify ip"
      v-if="showUpdate"
      :activate="showUpdate"
      @activate="showUpdate = $event"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ ipModelUpdateModel.created_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>updated at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ ipModelUpdateModel.updated_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ ipModelUpdateModel.deleted_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>ip address</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  data-vv-scope="form-entry"
                  v-validate="'required'"
                  v-model="ipModelUpdateModel.ip_address"
                >
                <span v-if="errors.has('form-entry.ip_address')">
                  {{ errors.first('form-entry.ip_address') }}
                </span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>user id</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  data-vv-scope="form-entry"
                  v-validate="'required'"
                  v-model="ipModelUpdateModel.user_id"
                >
                <span v-if="errors.has('form-entry.user_id')">
                  {{ errors.first('form-entry.user_id') }}
                </span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Memo</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <text-area
                  name="memo"
                  data-vv-scope="form-entry"
                  v-validate="'required'"
                  v-model="ipModelUpdateModel.memo"
                  :content="ipModelUpdateModel.memo"
                ></text-area>
              </div>
              <span v-if="errors.has('form-entry.memo')">
                {{ errors.first('form-entry.memo') }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="update()"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import _ from 'lodash'

//= mixins
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import TextArea from '@/components/base/TextArea'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

export default {
  name: 'IP',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList,
    TextArea
  },

  mixins: [ swal, checkAll ],

  data () {
    let query = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      query,
      status: 'all',

      ipModel: this.getDefaultModel(),
      ipModelUpdateModel: this.getDefaultUpdateModel(),
      searchInput: '',

      filterBy: [
        {
          value: 'name',
          display: 'Name'
        }
      ],

      showCreate: false,
      showUpdate: false,
      showTblSettings: false,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      selected: [],
      selectAll: false,

      tblSetting: 'user_ips',

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'agent',
          value: 'agent'
        },
        {
          display: 'ip address',
          value: 'ip_address'
        },
        {
          display: 'memo',
          value: 'memo'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        },
        {
          display: 'user id',
          value: 'user_id'
        }
      ]
    }
  },

  computed: {
    ...mapState('ip', [ 'ips', 'count' ])
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.query = this.generate(this.query)
    this.search()
  },

  methods: {
    ...mapActions('ip', [ 'get', 'delete' ]),
    ...mapActions('ip', { createIP: 'create' }),
    ...mapActions('ip', { updateIP: 'update' }),
    ...mapActions('ip', { restoreIP: 'restore' }),

    getDefaultModel () {
      return {
        ip_address: '',
        user_id: '',
        memo: ''
      }
    },

    getDefaultUpdateModel () {
      return {
        id: '',
        ip_address: '',
        user_id: '',
        memo: ''
      }
    },

    async search (query) {
      this.query = query || this.query
      this.status = this.$route.params.status
      this.selected = []
      this.isEmpty = false

      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        status: this.status,
        params: this.query
      })

      this.isDataLoading = false
      this.showDataLoading = false

      if (!this.ips.length) {
        this.isEmpty = true
      }
    },

    async deleteData (index) {
      let success = async () => {
        let result = await this.delete({ data: this.selected })

        if (result.status === 202) {
          this.$alert('success', 'You have successfully delete the IP(s).', {}, '', 'Success')
          this.selected = []
          this.selectAll = false
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to delete the following IP(s)?', {}, { success }, 'Delete IP')
    },

    async create () {
      let success = async () => {
        let result

        result = await this.createIP(this.ipModel)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created IP.', {}, '', 'Success')
          this.ipModel = _.assign(this.ipModel, this.getDefaultModel())
          this.showCreate = false
          this.search()
        }
      }

      if (this.ipModel.ip_address.trim() === '') {
        this.$alert('error', 'Missing IP Address data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create IP')
    },

    async showUpdateForm (index) {
      const item = this.ips[index]
      this.ipModelUpdateModel = _.assign(this.ipModelUpdateModel, item)
      this.showUpdate = true
    },

    async update () {
      let success = async () => {
        const data = {
          ...this.ipModelUpdateModel
        }

        delete data.id
        delete data.created_at
        delete data.deleted_at
        delete data.user

        let result = await this.updateIP({
          id: this.ipModelUpdateModel.id,
          data: data
        })

        if (result.status === 204) {
          this.$alert('success', 'You have successfully modified the IP(s).', {}, '', 'Success')
          this.ipModelUpdateModel = this.getDefaultUpdateModel()
          this.showUpdate = false
          this.search()
        }
      }

      if (this.ipModelUpdateModel.ip_address.trim() === '') {
        this.$alert('error', 'Missing IP Address data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to modify this domain?', {}, { success }, 'Modify IP')
    },

    async trigger (query) {
      this.query = query || this.query
      this.$router.push({ query: this.query })
    },

    async restore (id) {
      let success = async () => {
        let result = await this.restoreIP({
          id: id,
          data: { deleted_at: null }
        })

        if (result.status === 204) {
          this.$alert('success', 'You have successfully restored the IP(s).', {}, '', 'Success')
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to restore this IP?', {}, { success }, 'Restore IP')
    },

    sort (sortBy) {
      if (this.query.sort === 'asc') {
        this.query.sort = 'desc'
      } else {
        this.query.sort = 'asc'
      }

      this.query.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    }
  }
}
</script>

<style scoped>
  input[type=checkbox] {
    width: 14px;
    height: 14px;
    border: 1px solid #a4a7a7;
  }

  input[type=checkbox]:checked {
    background: rgb(236, 2, 166);
  }

  .filter {
    display: flex;
    list-style: none;
  }

  .filter li {
    margin-right: 4px;
  }
</style>
